export default __webpack_public_path__ + "static/media/team4.9fac8097.png";